// Design System "Technical Precision"
// Input: fondo gris tecnico, borde 1px #E2E8F0, radio 8px.
// Foco: borde amarillo + halo de 2px del mismo color al 20%.
const Style = {

  input: 'relative mb-3 last:mb-0',
  textbox: `relative block w-full px-3 py-1.5 rounded-lg bg-white border border-solid border-outline
    text-body-md text-on-surface outline-none box-border transition-colors transition-shadow
    placeholder:text-slate-400
    focus:border-primary focus:shadow-[0_0_0_2px_rgba(255,184,0,0.20)] appearance-none disabled:opacity-50`,

  cardbox: '!p-4',

  success: 'border border-solid border-emerald-500',
  successIcon: 'absolute top-[2.45em] right-3',
  error: 'relative text-on-surface mb-0 border border-solid border-[#EF4444] bg-white placeholder:text-slate-400 shadow-[0_0_0_2px_rgba(239,68,68,0.15)]',
  warning: 'bg-[#FEF9C3] border border-solid border-[#FEF08A]',

}

export default Style;
